export default __webpack_public_path__ + "static/0166-cf4c75b157f37055b7adb3c233a6b5c0.png";